type Translate = (key: string, options?: Record<string, unknown>) => string;

export type QuotaFirstUseNotice = {
  body: string;
  title: string;
};

/** Texto del primer aviso de consumo. Lo leen el toast del robot y el bloque encima del saludo. */
export function getQuotaFirstUseNotice(t: Translate, quota: number): QuotaFirstUseNotice {
  return {
    body: t('chatbot:quota_first_use_body', { count: quota }),
    title: t('chatbot:quota_first_use_title'),
  };
}
